export default {
  init(components) {
    let shareButtonElement = document.querySelector(".featured-header .share-button"); 
    if (shareButtonElement) {
      components.get('share-button').on('enable-sticky', () => true);
    }
  },
};
